import { usageUnitLockPeriodReasonEnumList } from '../../../components/AgGrid/enumLists'

const usageUnitLockPeriodReasonValueGetter = (props) => {
  const { value } = props
  return usageUnitLockPeriodReasonEnumList(value)
}

export default usageUnitLockPeriodReasonValueGetter
